import { createSelector } from "@reduxjs/toolkit";

export const getLastLandingSlug = createSelector(
  (state) => state.navigation?.lastLandingSlug ?? null,
  (slug) => slug
);
